import React, { ReactNode } from 'react';
import * as styles from '../NavigationTabs/NavigationTabs.module.scss';
import {
  NavigationTabItem,
  NavigationTabs,
} from 'components/NavigationTabs/NavigationTabs';

export type SubHeaderLink = {
  path: string;
  name: string;
  count?: number;
  is_active: boolean;
  key?: string;
};

export type PageSubHeaderProps = {
  links: SubHeaderLink[];
  children?: ReactNode;
};

const PageSubHeader = React.forwardRef<HTMLDivElement, PageSubHeaderProps>(
  ({ links = [], children }, ref) => {
    return (
      <NavigationTabs ref={ref}>
        {links.map((link) => (
          <NavigationTabItem
            key={link.path}
            name={link.name}
            url={link.path}
            active={link.is_active}
            count={link.count}
            countAriaLabel={
              link.count ? `${link.name} ${link.count}` : undefined
            }
          />
        ))}

        {children && <div className={styles.secondaryItems}>{children}</div>}
      </NavigationTabs>
    );
  }
);

PageSubHeader.displayName = 'PageSubHeader';

export default PageSubHeader;
